<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingBaseDataConfig.channel')" prop="channelCode">
            <BjSelectLov v-model="queryParams.channelCode" lov-code="SCHL.CHANNEL_TYPE" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingBaseDataConfig.logo')" prop="systemFlagCode">
            <BjInput
              v-model="queryParams.systemFlagCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button
            v-permission:SettingBaseDataConfig_Delete
            type="primary"
            :disabled="tableOperationProp.notSelected"
            class="delete-btn"
            @click="onDeleteSelected"
            >{{ $t('delText') }}</el-button
          >
          <el-button
            v-permission:SettingBaseDataConfig_Add
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('addText') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="{ row }">
              <template v-if="false" />

              <template v-else-if="col.prop === 'channelCode'">
                {{ SCHL_CHANNEL_TYPE.bjGet(row[col.prop]) }}
              </template>

              <el-tag v-else-if="col.prop === 'status'" :type="row.status ? 'success' : 'info'">{{
                $t(STATUS_ENABLED_NUM.bjGet(row[col.prop]))
              }}</el-tag>
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-button
                v-permission:SettingBaseDataConfig_Edit
                type="text"
                class="edit-btn"
                @click="onEdit(row.id)"
                >{{ $t('editText') }}</el-button
              >
              <el-button
                v-if="row.status"
                v-permission:SettingBaseDataConfig_Status
                type="text"
                @click="onStatus(0, row)"
                >{{ $t('disableText') }}</el-button
              >
              <el-button
                v-if="!row.status"
                v-permission:SettingBaseDataConfig_Status
                type="text"
                @click="onStatus(1, row)"
                >{{ $t('enableText') }}</el-button
              >
              <!-- <el-button v-permission:SettingBaseDataConfig_Log type="text">{{ $t('logText') }}</el-button> -->
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { baseDataApi } from '@/api';
import { STATUS_ENABLED_NUM } from '@/utils/constants';
import DataForm from './components/DataForm.vue';

export default {
  name: 'SettingBaseDataConfigIndex',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_ENABLED_NUM,
      queryApi: baseDataApi.getThirdConfigs,
      // 查询参数
      queryParams: {
        channelCode: null,
        systemFlagCode: null,
      },
      labelsVersion: 2,
      labelList: [
        { label: 'SettingBaseDataConfig.table.channel', prop: 'channelCode', isCheck: true, disabled: false, width: '120' },
        { label: 'SettingBaseDataConfig.table.logo', prop: 'systemFlagCode', isCheck: true, disabled: false, width: '100' },
        { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false },
        { label: 'SettingBaseDataConfig.table.name', prop: 'appName', isCheck: true, disabled: false, width: '200' },
        { label: 'SettingBaseDataConfig.table.type', prop: 'appType', isCheck: true, disabled: false, width: '200' },
        { label: 'app_key', prop: 'appKey', isCheck: true, disabled: false, width: '100' },
        { label: 'app_secret', prop: 'appSecret', isCheck: true, disabled: false, width: '100' },
        { label: 'SettingBaseDataConfig.table.authorizeAddress', prop: 'authUrl', isCheck: true, disabled: false, width: '170' },
        { label: 'SettingBaseDataConfig.table.otherAddress', prop: 'otherUrl', isCheck: true, disabled: false, width: '135' },
        { label: 'SettingBaseDataConfig.table.apiAddress', prop: 'apiServiceUrl', isCheck: true, disabled: false, width: '150' },
        { label: 'SettingBaseDataConfig.table.callbackAddress', prop: 'callBackUrl', isCheck: true, disabled: false, width: '135' },
        { label: 'SettingBaseDataConfig.table.AuthorizeAccount', prop: 'authAccount', isCheck: true, disabled: false, width: '200' },
        { label: 'SettingBaseDataConfig.table.certificateTraffic', prop: 'certificateFlow', isCheck: true, disabled: false, width: '135' },
        { label: 'SettingBaseDataConfig.table.openPlatform', prop: 'platformAddress', isCheck: true, disabled: false, width: '165' },
        { label: 'SettingBaseDataConfig.table.account', prop: 'account', isCheck: true, disabled: false },
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false, width: '120' },
        { label: 'SettingBaseDataConfig.table.remark', prop: 'remark', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129 },
      ],
      selectedRow: null,
    };
  },
  computed: {
    SCHL_CHANNEL_TYPE() {
      return this.$store.state.values.SCHL_CHANNEL_TYPE || [];
    },
  },
  watch: {},
  mounted() {
    this.$store.dispatch('values/getValueList', 'SCHL.CHANNEL_TYPE');
  },
  methods: {
    /** 新增 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 编辑操作 */
    onEdit(id) {
      baseDataApi.getThirdConfigsDetail({ id }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$refs.DataForm.show(this.$lodash.clone(res));
        }
      });
    },
    /** 禁用 */
    onStatus(flag, row) {
      const TEXT = this.$t(STATUS_ENABLED_NUM.bjGet(flag));
      this.$confirm(`${this.$t('toast.youAreTipText')} ${TEXT} ${row.systemFlagCode}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            ...row,
            status: flag,
          });
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }

      if (this.selectedRows.some(e => e.status == 1)) {
        this.$message.warning(this.$t('toast.delEnabledTipText'));
        return;
      }

      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi(this.selectedRows.map(e => e.id));
        })
        .catch(() => {});
    },
    operationApi(API_DATA) {
      baseDataApi.putThirdConfigs(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(idList) {
      baseDataApi.deleteThirdConfigs({ idList }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
